import { httpConsulta } from "../../../../services/apiManagement/Http.interceptor";

export const getSeparations = (data:string) => {
  return httpConsulta.get(`/getExpedicaoByCd?cd=${data}`);
}

export const getDeliveryForecast = (cd:string, loja:string) => {
  return httpConsulta.get(`/GetPrevisaoEntrega`)
}

export const setDeliveryForecast = (data:any) => {
  return httpConsulta.post('/insertPrevisaoEntrega', data)
}

export const getDoca = (data:string) => {
  return httpConsulta.get(`/getParticularidadeDocaByCd?cd=${data}`)
}
